import dispatcher from "../dispatcher";

import rq from "../components/utility/rq";
export function login(email, password) {
    var data = {
        email,
        password
    };
    rq.post("/login", data).then((data) => {
        dispatcher.dispatch({ type: "loginSuccess", tokenData: data });
    }).catch((err) => {
        dispatcher.dispatch({ type: "loginFailed" });
        throw err;
    });
}
/**
 * 
 * @param {string email} email 
 * 
 */
export function recoverPassword(email) {

    rq.putJson("/passwordrecovery", { email }).then(() => {
        dispatcher.dispatch({ type: "passwordRecovered" });
    }).catch((err) => {
        dispatcher.dispatch({ type: "passwordRecoveryFailed" });
        throw err;

    });
}




// WEBPACK FOOTER //
// ./src/jsx/actions/auth-action.jsx